import { useContext } from "react";
import { PhantomStatusContext, type PhantomStatusState } from "./PhantomStatusProvider.tsx";

export function usePhantomStatus(): PhantomStatusState {
  const ctx = useContext(PhantomStatusContext);
  if (!ctx) {
    throw new Error("usePhantomStatus must be used inside <PhantomStatusProvider>");
  }
  return ctx;
}
